import { makeStyles, Theme } from '@material-ui/core/styles';

const style = makeStyles((theme: Theme) => ({
  formOuter: {
    width: '100%',
    maxWidth: 464,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 24,
    marginTop: 0,
  },
  fieldsGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  fieldWithLabel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  labelPhone: {
    margin: 0,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: '#000b33',
  },
  labelPostal: {
    margin: 0,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: '#383838',
  },
  input: {
    width: '100%',
    height: 40,
    border: '1px solid #d8d8d8',
    borderRadius: 8,
    padding: '0 12px',
    backgroundColor: '#fff',
    '&:before': {
      display: 'none',
    },
    '&:after': {
      display: 'none',
    },
    '& input': {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: 16,
      color: '#383838',
      padding: 0,
      '&::placeholder': {
        fontFamily: "'Open Sans', sans-serif",
        color: '#9CA3AF',
      },
    },
  },
  errorField: {
    color: theme.palette.warning.main,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 10,
    margin: 0,
  },
  submitSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'stretch',
    width: '100%',
  },
  btnConnect: {
    width: '100%',
    height: 40,
    background:
      'linear-gradient(86deg, #0E0D88 0.92%, #C93646 35.77%, #F49830 75.01%, #FED329 97.62%)',
    borderRadius: 0,
    color: '#fff',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '0.28px',
    textTransform: 'none' as const,
    '&:hover': {
      background:
        'linear-gradient(86deg, #0E0D88 0.92%, #C93646 35.77%, #F49830 75.01%, #FED329 97.62%)',
      opacity: 0.9,
    },
    '&.Mui-disabled': {
      color: 'rgba(255,255,255,0.7)',
    },
    '@media (max-width: 1249px)': {
      fontSize: 16,
      letterSpacing: '0.32px',
    },
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    alignSelf: 'flex-start',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
  },
  backText: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    color: '#383838',
    '@media (max-width: 1249px)': {
      fontSize: 16,
    },
  },
  registerError: {
    color: theme.palette.warning.main,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 12,
    textAlign: 'center' as const,
  },
}));

export default style;
